import { render, staticRenderFns } from "./PathwayProgressPanel.vue?vue&type=template&id=634a55dc&scoped=true"
import script from "./PathwayProgressPanel.vue?vue&type=script&lang=js"
export * from "./PathwayProgressPanel.vue?vue&type=script&lang=js"
import style0 from "./PathwayProgressPanel.vue?vue&type=style&index=0&id=634a55dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a55dc",
  null
  
)

export default component.exports